import { AnchorButton, Button } from "@svea/design-system-components-react";
import {
	ButtonGroup,
	FormHelperText,
	Heading,
	moneyFormatNoDecimal,
	P,
	Paper,
	Stack,
	useText,
} from "@sveabank/cc-common";
import { Link } from "react-router";
import PageNavigationFooter from "../../components/page-navigation-footer";
import { usePageContext } from "../../hooks/context";
import { usePackage } from "../../hooks/package";
import type { ChoosePackageError } from "../../types/package";
import { getAddonTotalPrice, getTotalPackageCost } from "./helpers";
import { useChoosePackage } from "./hooks";

type Props = {
	error?: ChoosePackageError;
	onContinue: () => void;
};

const ChoosePackageFooter = ({ error, onContinue }: Props) => {
	const { configureBankGiroIsLoading } = usePageContext(useChoosePackage);
	const { selectedPackage, selectedAddons } = usePackage();
	const [t, texts] = useText();

	const calculateTotalFee = () => {
		if (!selectedPackage) return 0;
		const packagePrice = getTotalPackageCost(selectedPackage);
		const addonTotal = getAddonTotalPrice(selectedAddons);

		return packagePrice + addonTotal;
	};

	return (
		<Paper
			plain
			className="bg-background-complementary-gray max-md:-mx-4 max-md:rounded-none max-md:border-none"
			padding="base"
		>
			<PageNavigationFooter paddingTop="none">
				<Stack gap={4} align="start">
					<Stack gap={1}>
						<P>{t(texts.choosePackage.totalAmount)}</P>
						<Heading.H3>{`${moneyFormatNoDecimal(calculateTotalFee(), true)}/mån`}</Heading.H3>
					</Stack>

					<ButtonGroup row align="start">
						<Button
							onPress={onContinue}
							isPending={configureBankGiroIsLoading}
							type="submit"
							form="bankgiroForm"
						>
							{t(texts.choosePackage.continue)}
						</Button>

						<AnchorButton variant="secondary" as={Link} to="/dashboard">
							{t(texts.common.abort)}
						</AnchorButton>
					</ButtonGroup>
				</Stack>
			</PageNavigationFooter>

			{error && (
				<FormHelperText error key={error.id} align="right">
					{error.message}
				</FormHelperText>
			)}
		</Paper>
	);
};

export default ChoosePackageFooter;
